import { gql } from '@apollo/client'

// eslint-disable-next-line import/prefer-default-export
export const getTopLevelPlace = gql`
  query GetPlace($placeId: ID!) {
    getPlace(placeId: $placeId) {
      topLevelPlaceId
    }
  }
`
